export {
  type TrustpilotReviewCardProps,
  TrustpilotReviewCard,
} from './TrustpilotReview';
